<h2 mat-dialog-title>
  <span class="heading">{{data.heading}}</span>
  <button (click)="close()" mat-icon-button color="primary" align="end" matTooltip="Close review dialog">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="form-fields">
  <reviews
    *ngIf="getTopics(); let topics"
    [topicsInfo]="topics"
    [cui]="data.cui"
    [voc]="data.voc"
    [code]="data.code"
    [data]="data.data"
    [userIsEditor]="data.userIsEditor"
    (run)="data.run.emit($event)">
  </reviews>
</mat-dialog-content>
